/**
 * Color Configuration Constants
 * Central location for all color-related values used in ThreeScene
 */

export const COLOR_CONFIG = {
  // Occupied apartment color
  OCCUPIED_COLOR: 0xff8870,
  OCCUPIED_COLOR_STRING: "#FF8870",
  
  // Arrow colors
  ARROW_YELLOW: 0xffff00,
  
  // Material colors
  WHITE: 0xffffff,
  
  // Ambient light
  AMBIENT_LIGHT_COLOR: 0xffffff,
  DIRECTIONAL_LIGHT_COLOR: 0xffffff,
};

/**
 * Creates gradient color configuration
 * @param {string} primaryColor - The primary color from the theme
 * @returns {Array} Gradient color stops
 */
export const createGradientColors = (primaryColor) => [
  {
    position: 0,
    color: "black",
  },
  {
    position: 0.7,
    color: "black",
  },
  {
    position: 1,
    color: primaryColor,
  },
];

/**
 * Floor material configuration
 */
export const FLOOR_MATERIAL_CONFIG = {
  roughness: 0.8,
  color: 0xffffff,
  metalness: 0.2,
  bumpScale: 1,
};
